import { render } from "./InsightTable.vue?vue&type=template&id=19b721fd&scoped=true"
import script from "./InsightTable.vue?vue&type=script&lang=js"
export * from "./InsightTable.vue?vue&type=script&lang=js"

import "./InsightTable.vue?vue&type=style&index=0&id=19b721fd&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/popinsight-tools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b721fd"]])

export default __exports__